<div class="boolean-yes-no-widget" [style.color]="textColor" [matTooltip]="tooltipKey ? (tooltipKey | translate) : ''"
  [matTooltipDisabled]="!tooltipKey" [class.cursor-pointer]="action" (click)="onClick()">
  @if (translationPrefix) {
  {{ (translationPrefix + '.' + (value ? 'YES' : 'NO')) | translate }}
  } @else {
  {{ value ? 'Yes' : 'No' }}
  }
</div>